<script setup lang="ts">
import { ChevronDown, ChevronUp } from 'lucide-vue-next';

withDefaults(
  defineProps<{
    expanded: boolean;
    label: string;
    labelClass?: string;
    iconClass?: string;
  }>(),
  { labelClass: 'font-semibold text-text-primary-900', iconClass: 'size-4 text-text-primary-600' },
);
</script>

<template>
  <div class="flex items-center gap-1.5">
    <span
      class="text-sm"
      :class="labelClass"
    >
      {{ label }}
    </span>
    <ChevronUp
      v-if="expanded"
      :class="iconClass"
    />
    <ChevronDown
      v-else
      :class="iconClass"
    />
  </div>
</template>
